import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmSyncDialogData {
  title: string;
  email: string | null;
}

@Component({
  selector: 'app-confirm-sync-dialog',
  templateUrl: './confirm-sync-dialog.component.html',
  styleUrls: ['./confirm-sync-dialog.component.scss'],
})
export class ConfirmSyncDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmSyncDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmSyncDialogData
  ) {}

  get hasEmail(): boolean {
    return !!this.data.email && this.data.email.trim().length > 0;
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
